// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"423":"167a7191","438":"e1be4f51","580":"a5410faf","681":"e18f3e75","770":"c2b227b3"}[chunkId] + ".css";
};